import 'lazysizes'
import './scss/fonts.scss'
import './scss/main.scss'
import './scss/vendor.scss'
import './tailwind.css'

import { datadogRum } from '@datadog/browser-rum'
import sniffer from 'sniffer'

import Menu from './components/Menu'
import Modal from './components/Modal'
import H from './highway'
import store from './store'
import { isProd, qs, qsa, redactValuesFromLogs } from './utils'

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

class App {
  menu

  constructor() {
    this.init()
    this.setup()
  }

  setup() {
    sniffer.addClasses(store.dom.body)
    store.flags.windows && store.dom.body.classList.add('is-windows')
    window.onload = () => this.onLoad()

    /**
     * Create Global variable from webpack for debugging purpose
     * VERSION is hash of the current build
     * BRANCH is the branch name of the current build
     * */
    window.VERSION = __VERSION__
    window.BRANCH = __BRANCH__

    datadogRum.init({
      applicationId: process.env.DATADOG_RUM_APPLICATION_ID,
      clientToken: process.env.DATADOG_RUM_CLIENT_TOKEN,
      service: 'marketing-website',
      env: isProd(window.location.hostname) ? 'prod' : 'dev',
      version: __VERSION__,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 50,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      //Trace all subdomains of earnin.com except ss.earnin.com
      allowedTracingUrls: [/https:\/\/(?!ss\.).*\.earnin\.com/],
      beforeSend(event, context) {
        redactValuesFromLogs(event)
        redactValuesFromLogs(context)
      },
    })
  }

  init() {
    store.dom.modalSMS = new Modal()
    this.menu = new Menu()

    this.highwayEvents()
  }

  onLoad = () => {
    this.activeLink()
    window.addEventListener('focus', () => (store.flags.active = true))
    window.addEventListener('blur', () => (store.flags.active = false))
    window.onresize = () => {
      store.bounds.ww = window.innerWidth
      store.bounds.wh = window.innerHeight

      store.resizeFn && store.resizeFn()
    }

    document.addEventListener('lazybeforeunveil', (e) => {
      const bg = e.target.getAttribute('data-bg')
      const video = e.target.getAttribute('data-video')
      if (bg) {
        e.target.style.backgroundImage = `url(${bg})`
      } else if (video) {
        e.target.src = video
      }
    })

    setTimeout(() => {
      if (qs('.logo svg')) {
        qs('.logo svg').style.display = 'block'
      }
    }, 500)
  }

  highwayEvents() {
    H.on('NAVIGATE_OUT', ({ from, to, location }) => {
      this.menu.close()
      store.dom.modalSMS.close()
      this.activeLink()

      const links = qsa('.js-site-link')
      links.forEach((link) => {
        link.classList.remove('is-active')
        if (link.href === location.href) {
          link.classList.add('is-active')
        }
      })

      // Analytics
      if (typeof gtag !== 'undefined') {
        gtag('config', 'G-BEJT7ZTTX4', {
          page_path: location.pathname,
          page_title: to && to.page ? to.page.title : 'Earnin',
          page_location: location.href,
        })
      }
    })
  }

  activeLink() {
    const links = qsa('.js-site-link')
    links.forEach((link) => {
      link.classList.remove('is-active')
      if (link.href === location.href) {
        link.classList.add('is-active')
      }
    })
  }

  bindInputs() {
    const inputs = Array.from(qsa('input'))
    inputs.forEach((elem) => {
      elem.addEventListener('focus', () => {
        elem.parentNode.classList.add('active')
      })

      elem.addEventListener('blur', () => {
        if (!elem.value.length) {
          elem.parentNode.classList.remove('active')
        } else {
          elem.parentNode.classList.add('active')
        }
      })
    })
  }
}

new App()
